import cx from 'classnames'
import { CSSProperties } from 'react'
import { emojis } from './emojis'
import s from './style.module.scss'

interface IEmojiProps {
  name: string | undefined
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  style?: CSSProperties
  isActive?: boolean
  onClick?: () => void
}

const Emoji = ({ name, size = 'sm', className, style, isActive, onClick }: IEmojiProps) => {
  if (!name || !emojis.includes(name)) return null

  const classList = cx(
    s.emoji,
    {
      [s[`size-${size}`]]: size,
      [s.active]: isActive
    },
    className
  )

  return (
    <div className={classList} style={style} onClick={onClick}>
      <img src={`/assets/images/emoji/${name}.gif`} alt={`emoji-${name}`} />
    </div>
  )
}

export default Emoji
